import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal
} from "@angular/core";
import { ValueChangedEvent } from "devextreme/ui/text_box";
import {
  ReportDesignerItemImage,
  ReportDesignerItemImageConfig
} from "src/app/modules/bootstrap/modules/report/report-design-item";

@Component({
  selector: "snt-report-designer-image",
  templateUrl: "report-designer-image.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerImageComponent implements OnInit {
  @Input()
  item!: ReportDesignerItemImage;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Output()
  config: EventEmitter<ReportDesignerItemImageConfig> = new EventEmitter();

  caption = signal<string>("");
  align = signal<"left" | "center" | "right">("left");

  ngOnInit(): void {
    this.align.set(this.item.config?.align || "left");
    this.caption.set(this.item.config?.caption);
  }

  onAlignChanged(align: "left" | "center" | "right"): void {
    this.align.set(align);
    this.config.emit({
      ...this.item!.config,
      align: align
    });
  }

  onCaptionValueChanged(dxEvent: ValueChangedEvent): void {
    this.config.emit({
      ...this.item!.config,
      caption: dxEvent.value || ""
    });
  }
}
